import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostAskRequest } from 'domain/usecases';
import { RemotePostAskRequest } from 'data/usecases/ask-customer';

export const makeRemotePostQueueRequest = (): PostAskRequest => {
  return new RemotePostAskRequest(makeApiUrl('/queue/requests'), makeAuthorizeHttpClientDecorator());
};
